import {Grid, InputLabel} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Dialog from 'components/Dialog';
import {GridCentered} from 'components/GridCentered';
import Formik from 'components/hook-form/Formik';
import FormikDropdown from 'components/inputs/FormikDropdown';
import FormikListBox from 'components/inputs/FormikListBox';
import FormikRadioButton from 'components/inputs/FormikRadioButton';
import FormikTextField from 'components/inputs/FormikTextField';
import Panel from 'components/Panel';
import {layoutSelectors} from 'features/layout/redux';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {ILogFilters, ILogFilterFormType, LogFilterFormType} from 'types/diplomat/logs/LogFilter';
import {enums} from 'types/enums';

const LogFilterForm = ({onClose}: {onClose: () => void}) => {
   const {t} = useTranslation();
   const names = useSelector(layoutSelectors.transactionNames);

   return (
      <>
         <Panel>
            <Grid container spacing={2}>
               <GridCentered item xs={4}>
                  <InputLabel>{t('Minimum Filter Level:')}</InputLabel>
               </GridCentered>
               <Grid item xs={8}>
                  <FormikDropdown
                     autoFocus
                     name="minimumLevel"
                     options={enums.minimumLevel.options}
                  />
               </Grid>

               <Grid item xs={4}>
                  <FormikRadioButton
                     name="filterType"
                     value={enums.filterType.TEXT_FILTER}
                     label={t('Search by Phrase:')}
                  />
               </Grid>
               <Grid item xs={8}>
                  <FormikTextField name="text" />
               </Grid>

               <Grid item xs={4}>
                  <FormikRadioButton
                     name="filterType"
                     value={enums.filterType.TRANS_FILTER}
                     label={t('Search by Transaction Name:')}
                  />
               </Grid>
               <Grid item xs={8}>
                  <FormikListBox name="transNames" options={names} />
               </Grid>
            </Grid>
         </Panel>
         <FormFooterButtons cancel={onClose} />
      </>
   );
};

type Props = {
   open: boolean;
   filter?: ILogFilters;
   onClose: (filter?: ILogFilterFormType) => void;
};

export const LogFilterDialog = React.memo(({open, filter, onClose}: Props) => {
   const {t} = useTranslation();

   return (
      <Dialog maxWidth={'sm'} open={open} close={onClose} header={t('Define Log Filter')}>
         <Formik initialValues={LogFilterFormType.cast(filter)} onSubmit={onClose}>
            <LogFilterForm onClose={onClose} />
         </Formik>
      </Dialog>
   );
});
